import { defineAnimationStyles } from "@chakra-ui/react"

export const animationStyles = defineAnimationStyles({
    bounce: {
        value: {
            animationName: "bounce",
            animationDuration: "1s",
            animationTimingFunction: "ease-in-out",
            animationIterationCount: "infinite",
        },
    },
})
